import Loadable from '../../components/loadable';

const BulkSuspendContacts = Loadable({
  loader: () => import('../../pages/reports/bulk_suspend_contacts/bulk_suspend_contacts'),
});

angular.module('gym').value('BulkSuspendContacts', BulkSuspendContacts);

const BulkSuspendContactsFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/bulk_suspend_contacts/bulk_suspend_contacts_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkSuspendContactsFiltersModal', BulkSuspendContactsFiltersModal);

const ConfirmBulkSuspendContacts = Loadable({
  loader: () => import('../../pages/reports/bulk_suspend_contacts/confirm_bulk_suspend_contacts'),
});

angular.module('gym').value('ConfirmBulkSuspendContacts', ConfirmBulkSuspendContacts);
